import styled from "styled-components";
import { Container } from "manifest-components/src/Containers";
import { getMobileBreakpoint, globalCSSVars } from "manifest-components/src/Styles/globals";

const AppContainer = styled(Container)`
  margin-left: auto;
  margin-right: auto;
  width: ${globalCSSVars.desktopWidth};
  padding-bottom: 80px;
  padding-top: 40px;

  @media (max-width: ${getMobileBreakpoint}) {
    padding-top: 0px;
    padding-bottom: 60px;
    width: ${globalCSSVars.mobileWidth};
  }
`;

export default AppContainer;
